// Contacto de ventas (plan Enterprise).
//
// Va con fetch directo y NO por client.js a propósito: ese cliente inyecta los
// headers de sesión y desloguea ante un 401, y este formulario es público —
// lo completa un visitante que todavía no tiene cuenta.

const API_URL = process.env.REACT_APP_API_URL || "";

const leadService = {
  /**
   * Registra un contacto de ventas.
   * @returns {Promise<{ok: boolean, error?: string}>}
   */
  create: async (payload) => {
    try {
      const res = await fetch(`${API_URL}/api/user-api/leads`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (res.ok) return { ok: true };

      // El backend devuelve {error} con mensaje para el usuario en 400 y 429.
      let error = "No pudimos registrar tu consulta. Probá de nuevo en unos minutos.";
      if (res.status === 429) {
        error = "Ya recibimos tu consulta. Te contactamos a la brevedad.";
      } else if (res.status === 400) {
        try {
          const data = await res.json();
          if (data?.error) error = data.error;
        } catch (_) {
          /* body no JSON: dejamos el mensaje genérico */
        }
      }
      return { ok: false, error };
    } catch (_) {
      return {
        ok: false,
        error: "No pudimos conectarnos. Revisá tu conexión e intentá de nuevo.",
      };
    }
  },
};

export default leadService;
